module.exports = __webpack_public_path__ + "static/resume-edf39cb7b7ecc88d2c6ff9dfb7af51da.pdf";